import React from "reactn";
import SectionOne from "./forms/SectionOne";
import SectionTwo from "./forms/SectionTwo";
class Setup extends React.Component {
  render() {
    return (
      <div className="cont boxes-row mt-50px" style={{ display: "flex", alignItems: "flex-start", gap: "20px" }}>
        <SectionOne
          initialPartyType={this.props.initialPartyType}
          initialAddChild={this.props.initialAddChild}
          initialManualInvoices={this.props.initialManualInvoices}
          initialApplicationRequired={this.props.initialApplicationRequired}
          allowSameEnrollment={this.props.allowSameEnrollment}
          vals={this.global.myApplicationProfileInfo}
        />
        <SectionTwo vals={this.global.myApplicationProfileInfo} />
      </div>
    );
  }
}

export default Setup;
